import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-terms-of-rental',
  templateUrl: './terms-of-rental.component.html',
  styleUrls: ['./terms-of-rental.component.scss']
})
export class TermsOfRentalComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  public productList: Array<any> = [];
  public imgUrl = environment.ImageUrl;

  constructor(
    private auth: AuthServiceService,
    private seoService: SeoService
  ) { }

  ngOnInit(): void {
    this.seoService.update({
      title: 'Kachiing Rental System Terms and Conditions',
      description: 'Kachiing Rental System Terms and Conditions. Our platform is designed not only for convenience and community but also for providing multiple income-generating opportunities. Whether you\'re passionate about maintaining a safe digital space, helping businesses improve, or sharing your expertise, Kachiing offers diverse ways for you to earn.'
    })
    this.getAllRentProduct();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAllRentProduct() {
    this.auth.getAllRentProdut().subscribe((resp: ApiResponse) => {
      this.productList = resp.body;
    });
  }

}
